import { render, staticRenderFns } from "./lista-de-direcciones.vue?vue&type=template&id=2cf4867e&"
import script from "./lista-de-direcciones.vue?vue&type=script&lang=ts&"
export * from "./lista-de-direcciones.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports